import React from 'react';
import axios from "axios";
import { Grid, useMantineTheme, Box, Group, Flex, ActionIcon, Card, SimpleGrid, Text, Badge, Mark, Chip, Select, TextInput } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { IconArrowsSort } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";

import { BE_API_ONE, utils } from "../../utils/globalVariables";
import { regexNoStriped, safeValue, getObjectParam2, numberWithComma, stringDivider, sqlDateToHumanDate } from "../../utils/globalFunctions";

import AmountOfData from "../../components/general/AmountOfData";
import ModalWrapperWithoutFooter from "../../components/general/ModalWrapperWithoutFooter";
import ModalWrapperWithFooterCloseButton from "../../components/general/ModalWrapperWithFooterCloseButton";

import LoaderLine from "../../components/general/LoaderLine";
import SortMenu from "../../components/general/SortMenu";
import NoData from "../../components/general/NoData";
import LabelContentInline from "../../components/general/LabelContentInline";

import ComponentInputJumlahPemakaianStock from "./ComponentInputJumlahPemakaianStock";
import ComponentInputJumlahTambahanStock from "../trxSelesai/ComponentInputJumlahTambahanStock";
import SearchInputComponent from "../../components/general/SearchInputComponent";

const ComponentStockSelector = ({
  children,
  stateShow,
  fnShow,
  stateData,
  statePreventNotChange,
  statePengerjaanProgresId,
  stateIsForTambahanStock = false,
  fnResult
}) => {

  const mountedRef = React.useRef(true);

  const theme = useMantineTheme();
  const { loginContext, handleSetLoginContext } = useLoginContext();

  const notificationId = React.useRef({
    errorGetData: 'componentStockSelector-1',
    errorGetDataCategory: 'componentStockSelector-2',
  })

  const filterDefaultRef = React.useRef({
    stockCategory: {
      show: false,
      id: utils.flagAll,
      name: '',
      isActive: '',
    },
    stockCategorySub: {
      show: false,
      id: utils.flagAll,
      name: '',
      isActive: '',
      categoryId: '',
      categoryName: '',
    },
    stockTanda: utils.flagAll,
  })

  const sortList = {
    stockCategory: {
      slug: 'stock_category_name',
      caption: 'Kategori',
      type: utils.sortType.string.slug
    },
    stockCategorySub: {
      slug: 'stock_category_sub_name',
      caption: 'Sub Kategori',
      type: utils.sortType.string.slug
    },
    stockMasaGaransiType: {
      slug: 'stock_masa_garansi_type',
      caption: 'Garansi',
      type: utils.sortType.string.slug
    },
    stockMasaGaransi: {
      slug: 'stock_masa_garansi_number',
      caption: 'Masa Garansi',
      type: utils.sortType.integer.slug
    },
    stockJumlah: {
      slug: 'stock_jumlah',
      caption: 'Jumlah Stok',
      type: utils.sortType.integer.slug
    },
    stockTanda: {
      slug: 'stock_status',
      caption: 'Tanda',
      type: utils.sortType.string.slug
    },
  }

  const [data, setData] = React.useState({
    data: [],
    dataCount: 0,
    dataFlag: 'idle',
    dataLoading: false,
    dataRefresh: new Date(),
    dataOffset: 0,
    dataSortSelected: sortList.stockCategory,
    dataSearchInputForBE: '',

    taggedForThisClientProject: '0',
    taggedForThisClientProjectData: [],

    dataLoadingCategory: false,
    dataCategory: [],

    taggedInfo: {
      modal: false,
      customerName: '',
      projectId: ''
    },

    filterData: {
      drawer: false,
      stockCategory: filterDefaultRef.current.stockCategory.id,
      stockCategorySub: filterDefaultRef.current.stockCategorySub,
      stockTanda: filterDefaultRef.current.stockTanda,
    },
  });

  React.useEffect(() => {
    return () => {
      mountedRef.current = false;
    }
  }, [])

  const fnSort = (stateSortSelected) => {
    setData(d => ({
      ...d,
      dataLoading: true,
      dataSortSelected: {
        ...d.dataSortSelected,
        slug: d.dataSortSelected.slug[0] === '-' ? stateSortSelected.slug : '-' + stateSortSelected.slug,
        caption: stateSortSelected.caption,
        type: stateSortSelected.type
      }
    }));
  };

  const AmountOfDataComponent = () => {
    return (
      <AmountOfData
        stateDataLimit={utils.dataLimit}
        stateDataOffset={data.dataOffset}
        stateAmountDataAll={data.dataCount}
        stateDataFlag={data.dataFlag}
        stateSuffix=''

        fnFirstData={(stateNewOffset) => setData(d => ({
          ...d,
          dataLoading: true,
          dataRefresh: new Date(),
          dataOffset: stateNewOffset
        }))}

        fnLastData={(stateNewOffset) => setData(d => ({
          ...d,
          dataLoading: true,
          dataRefresh: new Date(),
          dataOffset: stateNewOffset
        }))}

        fnPreviousData={(stateNewOffset) => setData(d => ({
          ...d,
          dataLoading: true,
          dataRefresh: new Date(),
          dataOffset: stateNewOffset
        }))}

        fnNextData={(stateNewOffset) => setData(d => ({
          ...d,
          dataLoading: true,
          dataRefresh: new Date(),
          dataOffset: stateNewOffset
        }))}
      />
    )
  }

  React.useEffect(() => {
    setData(d => ({ ...d, dataLoadingCategory: true }));

    const formDT = new FormData();
    const formDTHeader = { 'Content-Type': 'application/json' }

    formDT.append('json_token', loginContext.syswebapp);
    formDT.append('flag_all', utils.flagAll);
    formDT.append('filter_is_active', utils.flagAll);

    axios({
      method: 'post',
      url: BE_API_ONE + '/category_item_all_get',
      data: formDT,
      headers: formDTHeader,
    }).then((response) => {
      if (!mountedRef.current) return null;

      setData(d => ({ ...d, dataLoadingCategory: false }));

      if (response.data.flag_status === 'isset') {
        setData(d => ({ ...d, dataCategory: response.data.data }));
      }

      if (response.data.flag_status === 'invalid-json-token') {
        handleSetLoginContext(null);
      }

      if (response.data.flag_status === 'user-inactive') {
        handleSetLoginContext(null);
      }
    }).catch(error => {
      if (!mountedRef.current) return null;

      setData(d => ({ ...d, dataLoadingCategory: false }));

      notifications.show({
        id: notificationId.current.errorGetDataCategory,
        title: utils.notification.warning.caption,
        message: error.message,
        color: utils.notification.warning.color,
        icon: utils.notification.warning.icon,
        withBorder: true,
        autoClose: true,
      })
    })
  }, [handleSetLoginContext, loginContext.syswebapp])

  React.useEffect(() => {
    setData(d => ({ ...d, dataLoading: true }));

    const formDT = new FormData();
    const formDTHeader = { 'Content-Type': 'application/json' }

    formDT.append('json_token', loginContext.syswebapp);
    formDT.append('data_limit', utils.dataLimit);
    formDT.append('data_offset', data.dataOffset);
    formDT.append('order_by', regexNoStriped(data.dataSortSelected.slug));
    formDT.append('order_type', data.dataSortSelected.slug[0] === '-' ? 'asc' : 'desc');

    formDT.append('flag_all', utils.flagAll);
    formDT.append('filter_search', data.dataSearchInputForBE);
    formDT.append('filter_stock_category', data.filterData.stockCategory);
    formDT.append('filter_stock_category_sub', data.filterData.stockCategorySub.id);
    formDT.append('filter_stock_supplier', utils.flagAll);
    formDT.append('filter_stock_is_active', '1');

    formDT.append('filter_stock_tanggal_beli_dari', utils.flagAll);
    formDT.append('filter_stock_tanggal_beli_sampai', utils.flagAll);
    formDT.append('filter_stock_tanda', data.filterData.stockTanda);
    formDT.append('filter_stock_garansi_type', utils.flagAll);

    //

    formDT.append('tagged_only', data.taggedForThisClientProject);
    formDT.append('project_id', stateData.projectId ? stateData.projectId : utils.flagAll);
    formDT.append('project_process', stateData.projectProcess ? stateData.projectProcess : utils.flagAll);
    formDT.append('project_is_cancel', stateData.projectIsCancel ? stateData.projectIsCancel : utils.flagAll);
    formDT.append('stock_item_tagging_status_obj', JSON.stringify(utils.stockItemStatus));
    formDT.append('stock_item_garansi_status_obj', JSON.stringify(utils.statusItemGaransi));

    axios({
      method: 'post',
      url: BE_API_ONE + '/get_stock',
      data: formDT,
      headers: formDTHeader,
    }).then((response) => {
      if (!mountedRef.current) return null;

      setData(d => ({ ...d, dataLoading: false }));

      if (response.data.flag_status === 'isset') {
        setData(d => ({
          ...d,
          data: response.data.data,
          taggedForThisClientProjectData: Array.isArray(response.data.data_tagged_stock_in_ms_stock) ? response.data.data_tagged_stock_in_ms_stock : [],

          dataCount: response.data.data_count,
          dataFlag: response.data.data.length > 0 ? true : false,
        }));
      }

      if (response.data.flag_status === 'invalid-json-token') {
        handleSetLoginContext(null);
      }

      if (response.data.flag_status === 'user-inactive') {
        handleSetLoginContext(null);
      }
    }).catch(error => {
      if (!mountedRef.current) return null;

      setData(d => ({
        ...d,
        dataLoading: false,
      }));

      notifications.show({
        id: notificationId.current.errorGetData,
        title: utils.notification.warning.caption,
        message: error.message,
        color: utils.notification.warning.color,
        icon: utils.notification.warning.icon,
        withBorder: true,
        autoClose: true,
      })
    })
  }, [handleSetLoginContext, loginContext.syswebapp, data.dataRefresh, data.dataSearchInputForBE, data.dataSortSelected.slug, data.dataOffset, data.filterData.stockCategory, data.filterData.stockCategorySub.id, data.filterData.stockTanda, statePreventNotChange, data.taggedForThisClientProject, stateData.projectId, stateData.projectProcess, stateData.projectIsCancel])

  return (
    <React.Fragment>
      {children}

      <ModalWrapperWithoutFooter
        stateShow={stateShow}
        fnHide={fnShow}
        stateHideOnClickOutSide={true}
        stateTitle={String('Daftar Stok').toUpperCase()}
        stateSize='100%'
        stateOverlayZIndex={201}
        stateWithCloseButton={true}
      >
        <Box sx={{ position: 'relative' }}>
          <Group
            noWrap
            mb='sm'
            pb="sm"
            spacing='.25rem'

            sx={{
              borderBottom: `1px solid ${theme.colorScheme === 'light' ? theme.colors.gray[3] : theme.colors.dark[5]}`
            }}
          >
            <SortMenu
              stateSortList={sortList}
              stateSortSelected={data.dataSortSelected}
              stateComponentTarget={<ActionIcon
                size='lg'
                variant="default"
                radius='xl'
              >
                <IconArrowsSort size='1.25rem' stroke={1} />
              </ActionIcon>}
              fnSort={fnSort}
            />

            <SearchInputComponent
              statePlaceHolder='Search Stok'
              fnDoSearch={(val) => setData(d => ({
                ...d,
                dataOffset: 0,
                dataSearchInputForBE: val,
                dataRefresh: new Date(),
              }))}
            />

            {data.dataLoadingCategory ?
              <TextInput
                readOnly
                radius='md'
                placeholder='Loading Kategori..'
              />
              :
              <Select
                radius='md'
                placeholder='Kategori'
                value={data.filterData.stockCategory}
                onChange={(val) => {
                  setData(d => ({
                    ...d,
                    filterData: {
                      ...d.filterData,
                      stockCategory: val
                    }
                  }))
                }}

                data={[
                  { value: utils.flagAll, label: 'Semua Kategori' },
                  ...data.dataCategory.map(key => ({ value: key.stock_category_id, label: key.stock_category_name }))
                ]}
              />
            }
          </Group>

          {data.dataLoading &&
            <LoaderLine
              statePosition='absolute'
              stateIsTop={false}
            />
          }
        </Box>

        {Array.isArray(data.taggedForThisClientProjectData) && (data.taggedForThisClientProjectData.length > 0) ?
          <Box mb='sm'>
            <Chip.Group
              multiple={false}
              value={data.taggedForThisClientProject}
              onChange={(val) => setData(d => ({
                ...d,
                taggedForThisClientProject: val,
                dataRefresh: new Date(),
                dataLoading: true,
              }))}
            >
              <Group spacing='.25rem'>
                <Chip value="0">Semua Item</Chip>
                <Chip value="1">
                  {data.taggedForThisClientProjectData.length} item khusus client/project ini
                </Chip>
              </Group>
            </Chip.Group>
          </Box>
          :
          <Text size='sm' mb='sm' color='dimmed'>Tidak ada item yang di tag untuk client/project ini.</Text>
        }

        {data.data.length > 0 &&
          <SimpleGrid
            cols={1}
            spacing='sm'
            breakpoints={[
              { minWidth: 'xl', cols: 4, spacing: 'sm' },
              { minWidth: 'lg', cols: 3, spacing: 'sm' },
              { minWidth: 'md', cols: 2, spacing: 'sm' },
              { minWidth: 'sm', cols: 2, spacing: 'sm' },
              { minWidth: 'xs', cols: 2, spacing: 'sm' },
            ]}
          >
            {Object.keys(data.data).map((key, index) => {
              return (
                <Card
                  key={key}
                  shadow=''
                  radius="md"
                  withBorder={true}

                  sx={(tema) => ({
                    borderColor: tema.colorScheme === 'light' ? tema.colors.gray[2] : tema.colors.dark[7],
                    backgroundColor: tema.colorScheme === 'light' ? tema.colors.gray[0] : tema.colors.dark[6],
                    overflow: 'unset',
                  })}
                >
                  <Card.Section p='sm'>
                    <LabelContentInline
                      stateColLabel={4}
                      stateLabel={<Text size='sm'>Kategori</Text>}
                      stateContent={
                        <Text size='sm'>{data.data[key].stock_category_name}</Text>
                      }
                      stateDividerMB='.25rem'
                      stateDividerMT='.25rem'
                      stateDivider={true}
                    />

                    <LabelContentInline
                      stateColLabel={4}
                      stateLabel={<Text size='sm'>Sub Kategori</Text>}
                      stateContent={
                        <Text size='sm'>{data.data[key].stock_category_sub_name}</Text>
                      }
                      stateDividerMB='.25rem'
                      stateDividerMT='.25rem'
                      stateDivider={true}
                    />

                    <LabelContentInline
                      stateColLabel={4}
                      stateLabel={<Text size='sm'>SN</Text>}
                      stateContent={
                        <Text
                          size='sm'
                          sx={{ wordBreak: 'break-word' }}
                        >
                          {safeValue(data.data[key].stock_serial_number, '-')}
                        </Text>
                      }
                      stateDividerMB='.25rem'
                      stateDividerMT='.25rem'
                      stateDivider={true}
                    />

                    <LabelContentInline
                      stateColLabel={4}
                      stateLabel={<Text size='sm'>Supplier</Text>}
                      stateContent={
                        <Text size='sm'>{data.data[key].supplier_name}</Text>
                      }
                      stateDividerMB='.25rem'
                      stateDividerMT='.25rem'
                      stateDivider={true}
                    />

                    <LabelContentInline
                      stateColLabel={4}
                      stateLabel={<Text size='sm'>Tanggal Beli</Text>}
                      stateContent={
                        <Text size='sm'>
                          {sqlDateToHumanDate({
                            stateDate: data.data[key].stock_tanggal_beli,
                            stateWithTime: false,
                            stateLang: 'id',
                            stateIsShort: false,
                            stateDay: false,
                            stateDefaultValue: ' - ',
                            stateDateType: 'day',
                            stateWithSecond: false
                          })}
                        </Text>
                      }
                      stateDividerMB='.25rem'
                      stateDividerMT='.25rem'
                      stateDivider={true}
                    />

                    <LabelContentInline
                      stateColLabel={4}
                      stateLabel={<Text size='sm'>Garansi</Text>}
                      stateContent={
                        <Group spacing='xs'>
                          <Text size='sm'>
                            {getObjectParam2(utils.masaGaransi, data.data[key].stock_masa_garansi_type, 'caption', '-')}
                          </Text>

                          <Group spacing={6} noWrap>
                            <Text size='sm'>
                              {safeValue(data.data[key].stock_masa_garansi_bulan, '-')} Bln
                            </Text>

                            <Text size='sm'>
                              {safeValue(data.data[key].stock_masa_garansi_hari, '-')} Hr
                            </Text>
                          </Group>
                        </Group>
                      }
                      stateDividerMB='.25rem'
                      stateDividerMT='.25rem'
                      stateDivider={true}
                    />

                    <LabelContentInline
                      stateColLabel={4}
                      stateLabel={<Text size='sm'>Jumlah Stok</Text>}
                      stateContent={
                        <Box>
                          <Group>
                            <Text size='sm'>
                              {numberWithComma(data.data[key].stock_jumlah)}
                            </Text>

                            <Badge
                              size='md'
                              color={getObjectParam2(utils.stockItemStatus, data.data[key].stock_status, 'color', 'gray')}

                              onClick={
                                // data.data[key].stock_status === utils.stockItemStatus.tagged.value ?
                                () => {
                                  setData(d => ({
                                    ...d,
                                    taggedInfo: {
                                      ...d.taggedInfo,
                                      customerName: data.data[key].customer_name,
                                      projectId: data.data[key].tagged_project_id,
                                      modal: true
                                    }
                                  }));
                                }
                                // :() => { }
                              }

                              sx={(tema) => ({
                                cursor: 'pointer',
                                // cursor: data.data[key].stock_status === utils.stockItemStatus.tagged.value ? 'pointer' : 'default'
                              })}

                              styles={(tema) => ({
                                inner: {
                                  fontWeight: 'normal',
                                  textTransform: 'none',
                                }
                              })}
                            >
                              {getObjectParam2(utils.stockItemStatus, data.data[key].stock_status, 'caption', ' - ')}
                            </Badge>
                          </Group>
                        </Box>
                      }
                      stateDividerMB='.25rem'
                      stateDividerMT='.25rem'
                      stateDivider={true}
                    />

                    {(data.data[key].customer_name) || (data.data[key].tagged_project_id) ?
                      <LabelContentInline
                        stateColLabel={12}
                        stateLabel={
                          <Group spacing='xs'>
                            <Text size='sm'>Tagged</Text>

                            {data.data[key].customer_name &&
                              <Badge
                                size='md'
                                color={getObjectParam2(utils.stockItemStatus, data.data[key].stock_status, 'color', 'gray')}

                                styles={(tema) => ({
                                  inner: {
                                    fontWeight: 'normal',
                                    textTransform: 'none',
                                  }
                                })}
                              >
                                {safeValue(data.data[key].customer_name, ' - ')}
                              </Badge>
                            }

                            {data.data[key].tagged_project_id &&
                              <Badge
                                size='md'
                                color={getObjectParam2(utils.stockItemStatus, data.data[key].stock_status, 'color', 'gray')}

                                styles={(tema) => ({
                                  inner: {
                                    fontWeight: 'normal',
                                    textTransform: 'none',
                                  }
                                })}
                              >
                                {stringDivider(data.data[key].tagged_project_id, [4, 6, 8], '.', ' - ')}
                              </Badge>
                            }
                          </Group>
                        }
                        stateContent=''
                        stateDividerMB='.25rem'
                        stateDividerMT='.25rem'
                        stateDivider={true}
                      />
                      :
                      <LabelContentInline
                        stateColLabel={12}
                        stateLabel={<Text size='sm'>&nbsp;</Text>}
                        stateContent={<Text size='sm'>&nbsp;</Text>}
                        stateDividerMB='.25rem'
                        stateDividerMT='.25rem'
                        stateDivider={true}
                      />
                    }

                    <Grid>
                      <Grid.Col
                        span={12}
                        sx={{
                          color: theme.colorScheme === 'light' ? theme.colors.gray[6] : theme.colors.gray[6]
                        }}
                      >
                        {stateIsForTambahanStock === true &&
                          <ComponentInputJumlahTambahanStock
                            // stateKey={key}
                            stateData={stateData}
                            stateDataStock={data.data[key]}
                            fnRes={(newData) => {
                              fnShow();
                              fnResult(newData);
                            }}
                          />
                        }

                        {!stateIsForTambahanStock &&
                          <ComponentInputJumlahPemakaianStock
                            stateKey={key}
                            stateData={stateData}
                            stateDataStock={data.data[key]}
                            statePengerjaanProgresId={statePengerjaanProgresId}
                            fnRes={(newData) => {
                              fnShow();
                              fnResult(newData);
                            }}
                          />
                        }
                      </Grid.Col>
                    </Grid>
                  </Card.Section>
                </Card>
              )
            })}
          </SimpleGrid>
        }

        {data.data.length <= 0 &&
          <NoData />
        }

        <Flex
          justify="flex-end"
          align="center"
          direction="row"
          wrap='nowrap'
          mt='lg'
        >
          <AmountOfDataComponent />
        </Flex>
      </ModalWrapperWithoutFooter>

      <ModalWrapperWithFooterCloseButton
        stateShow={data.taggedInfo.modal}
        fnHide={() => setData(d => ({ ...d, taggedInfo: { ...d.taggedInfo, modal: false } }))}
        stateHideOnClickOutSide={true}
        stateTitle={String('Information').toUpperCase()}
        // stateSize='xl'
        stateOverlayZIndex={201}
        stateWithCloseButton={true}
        stateScrollArea={true}

        stateButtonCloseCaption="Close"
        stateButtonCloseSize="xs"
        stateButtonClosePx="lg"
      >
        {data.taggedInfo.customerName ?
          <Text size='sm' color='dimmed'>
            Item ini sudah ditandai untuk customer <Mark>&nbsp;{safeValue(data.taggedInfo.customerName, ' - ')}&nbsp;</Mark>
          </Text>
          :
          <Text size='sm' color='dimmed'>
            Tidak ada customer tag untuk item ini.
          </Text>
        }

        {data.taggedInfo.projectId ?
          <Text size='sm' color='dimmed'>
            Item ini sudah ditandai untuk project <Mark>&nbsp;{stringDivider(data.taggedInfo.projectId, [4, 6, 8], '.', ' - ')}&nbsp;</Mark>
          </Text>
          :
          <Text size='sm' color='dimmed'>
            Tidak ada project tag untuk item ini.
          </Text>
        }
      </ModalWrapperWithFooterCloseButton>
    </React.Fragment>
  )
}

export default React.memo(ComponentStockSelector);